import { useField } from "formik";
import { type JSX, useCallback } from "react";
import { t } from "ttag";

import { FormField } from "metabase/forms";
import { Button } from "metabase/ui";

export interface DatabaseAuthProviderSectionFieldProps {
  name: string;
}

const DatabaseAuthProviderSectionField = ({
  name,
}: DatabaseAuthProviderSectionFieldProps): JSX.Element => {
  const [{ value }, , { setValue }] = useField(name);

  const handleClick = useCallback(() => {
    setValue(!value);
  }, [value, setValue]);

  return (
    <FormField mb="lg">
      <Button
        w="fit-content"
        variant="transparent"
        size="compact-md"
        onClick={handleClick}
      >
        {value ? t`Use password` : t`Use an authentication provider`}
      </Button>
    </FormField>
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default DatabaseAuthProviderSectionField;
